'use strict';
function changeReviewTableStructure() {
    var labels = jQuery('.gfield > table:not(.gfield_list) tr[bgcolor="#eaf2fa"]'), values = jQuery('.gfield > table:not(.gfield_list) tr[bgcolor="#ffffff"]');
    labels.each(function (i) {
        var current = jQuery(this), row = jQuery("<tr/>"), label = current.find('td').html(), value = values.eq(i).children('td').last().html();
        /**
         * Remove the existing value row
         */
        values.eq(i).remove();
        /**
         * Create a new row
         */
        row
            .append(jQuery('<td/>').html(label))
            .append(jQuery('<td/>').html(value))
            .addClass('section-field');
        /**
         * Replace existing label
         */
        current.replaceWith(row);
    });
    jQuery('.gfield table[bgcolor]').attr('bgcolor', '');
    jQuery('.gfield table[bgcolor]').parent().addClass('u-p-0').css('border', 0);
}
if (jQuery('.gform_wrapper').length) {
    changeReviewTableStructure();
}
